<div class="row">
    <div class="col-md-12">
        <h2>Contact US</h2>
        </div>
</div>
<app-home-card-config [contenttype]="'contact_us'">></app-home-card-config>
    